import React, { Component } from 'react'
import { Layout, Button, Typography } from 'antd';
import { Link } from "react-router-dom";
import relogin from '../../assets/image/relogin.png'
import "./errorInfo.scss";
const { Title, Text } = Typography;

export default class OutPages extends Component {


  render() {
    return (
      <Layout className='laystyle'>
        <div className='laycontent'>
          <div className='contentleft'>
            <img alt="" src={relogin} />
          </div>
          <div className='contentright'>
            <Title level={3}>
              {/* 由于您的帐号已在其他地方登录，系统已自动登出，请注意安全 */}
              账号存在异常，系统已自动登出，请稍后重新尝试
            </Title>
            <Text className='CRtext'>
              {/* 点击下方按钮并重新输入账号密码，可再次登录 */}
              确认账号状态，点击下方按钮重新输入账号密码，可再次登录
            </Text>
            <Link to='/login' className='CRbutton'>
              <Button>重新登录</Button>
            </Link>
          </div>
        </div>
      </Layout>
    )
  }
}